import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { map, mergeMap, catchError, retry } from 'rxjs/operators';
import { Entrance } from '../models/entrance';

@Injectable({
	providedIn: 'root'
})

export class EntranceService {

	constructor(private http: HttpClient, private authService: AuthService) { }

	// getStoreEntrances(storeGuid: string): Promise<Observable<Entrance[]>> {
	// 	return this.authService.GetDefaultHeaders().then((contentHeaders: HttpHeaders) => {

	// 		let entranceApiUrl = ConfigService.APP_API_ENDPOINT + "entrance/store";

	// 		// NOTE: Backend failed to recognize storeGuid in headers. Must resort to inline method
	// 		//contentHeaders = contentHeaders.append("storeGuid", storeGuid);
	// 		let entranceApiUrl_inline: string = entranceApiUrl + "?storeGuid=" + storeGuid;

	// 		// make http get request
	// 		return this.http.get<Entrance[]>(entranceApiUrl_inline, { headers: contentHeaders }).pipe(
	// 			retry(3), // retry a failed request up to 3 times
    //   			catchError(this.handleError), // then handle the error
	// 			map(res => res['objectdata']) // on success, data is within 'objectdata' in json
	// 		);
	// 	});
	// }

	getStoreEntrances(storeGuid: string) {
		let entranceApiUrl_inline: string = ConfigService.APP_API_ENDPOINT + "entrance/store" + "?storeGuid=" + storeGuid;
        return from(this.authService.GetDefaultHeaders()).pipe(
            mergeMap(contentHeaders => { return this.http.get(entranceApiUrl_inline, { headers: contentHeaders }) }),
            map((response:any) => { return response.objectdata }),
			retry(3),
            catchError(error => {
                return this.handleError(error);
            })
        );
	}
	
	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
		  // A client-side or network error occurred. Handle it accordingly.
		  console.error('An error occurred:', error.error.message);
		} else {
		  // The backend returned an unsuccessful response code.
		  // The response body may contain clues as to what went wrong,
		  console.error(
			`Backend returned code ${error.status}, ` +
			`body was: ${error.error}`);
		}
		// return an observable with a user-facing error message
		return throwError(
		  'Unable to fetch Entrances; please try again later.');
	};
}
